import { apiBaseUrl, imageBaseUrl } from '../utils/constants';

/**
 * Centralized environment-backed configuration (CRA: REACT_APP_* vars).
 */
export const env = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || apiBaseUrl,
  imageBaseUrl: process.env.REACT_APP_IMAGE_BASE_URL || imageBaseUrl,
  cvApiKey: process.env.REACT_APP_CV_API_KEY || '',
} as const;
